import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingService } from '@ibe.services/booking.tap.service';
import { MybService } from '@ibe.services/myb.tap.service';
import { SidebarService } from '@ibe/services/ui';
import { ExtraSidebar } from '../ancillaries/extra-sidebar.abstract';

@Component({
	selector: 'indra-wifi-onboard',
	template: '<div>loading indra template...check modules and routes</div>'
})
export class WifiOnboardComponent extends ExtraSidebar {

	constructor(
		sidebarService: SidebarService,
		route: ActivatedRoute,
		router: Router,
		bookingService: BookingService,
		mybService: MybService
	) {
		super(sidebarService, route, router, bookingService, mybService);
	}

}
